export default {"src":"/_next/static/media/map.bb84f550.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};